export const API_STATUS = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  SUCCESS_LOADING: 'SUCCESS_LOADING',
  RETRY: 'RETRY',
  ERROR: 'ERROR',
  NONE: 'NONE',
};
